<script setup>
import { ref, reactive, onMounted, nextTick, onBeforeUnmount, computed } from "vue";
import { createRule, getCountries } from "@/services/rules";
import { getProjects } from "@/services/projects";
import {
  getProjectChannels,
  /* postTimesToContactChannels */
} from "@/services/channels";
import CreatedRule from "@/components/Rules/CreatedRule";
import ReCaptcha from '../ReCaptcha.vue';
const emit = defineEmits(['close', 'rule-updated']);
const recaptchaRef = ref(null);

const days = [
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
  "Domingo",
];

/* const hours = Array.from({ length: 24 }, (_, index) => {
  const hour = index.toString().padStart(2, "0");
  return `${hour}:00`;
}).filter((hour) => {
  const hourValue = parseInt(hour.split(":")[0]);
  return hourValue >= 8 && hourValue <= 20;
}); */

const projects = ref([]);
const projectsLoaded = ref(false);
const projectHasNoChannels = ref(false);

const countries = ref([]);
const countriesLoaded = ref(false);
const holidays = reactive({
  enabled: false, //mostrar/ocultar el select del país
  country: "",
});

const stepperBgRef = ref(null);
const formContentRef = ref(null);

function syncStepperHeight() {
  if (stepperBgRef.value && formContentRef.value) {
    stepperBgRef.value.style.height = formContentRef.value.offsetHeight + 'px';
  }
}

onMounted(async () => {
  const clientId = localStorage.getItem("cx");
  console.log("Client ID:", clientId);
  if (!clientId) {
    console.error("Client ID not found in localStorage");
    return;
  }
  try {
    const response = await getProjects(clientId);
    console.log("Fetched Projects:", response.data);
    if (response.data.length) {
      projects.value = response.data;
      projectsLoaded.value = true;
    }
    console.log("PROYECTS:", projects.value);

    // Obtener países
    const countriesResponse = await getCountries();
    countries.value = countriesResponse.data;
    console.log("Countries response:", countriesResponse.data);
    countriesLoaded.value = true;
  } catch (error) {
    console.error("Error fetching rules:", error);
    console.error("Error fetching projects or countries:", error);
  }
  nextTick(syncStepperHeight);
  window.addEventListener('resize', syncStepperHeight);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', syncStepperHeight);
});

const showDates = ref(false);
const showTimes = ref(false);
const ruleCreated = ref(false);
const missingFieldsError = ref(false);
const formSubmitted = ref(false);
const showCreatedRule = ref(false);

const ruleData = reactive({
  name: "",
  monday: false,
  tuesday: false,
  wednesday: false,
  thursday: false,
  friday: false,
  saturday: false,
  sunday: false,
  startTime: "",
  endTime: "",
  country: "",
  emailTimes: "",
  smsTimes: "",
  callCenterTimes: "",
  showDates: showDates.value,
  notExpire: !showDates.value,
  expire: showDates.value,
  validityStartDate: "",
  validityEndDate: "",
  contactType: "month",
  isMonth: true,
  isWeek: false,
  timesContactDaily: 0,
  clientsId: localStorage.getItem("cx"), //?
  keytypesId: 1, //?
  catperiodId: 2, //?
  projectsId: "",
  channels: [],
});

// Validación
function validateForm() {
  formSubmitted.value = true;
  const requiredFields = ["name", "projectsId"];

  const isValid = requiredFields.every((field) => ruleData[field]);

  const isDaySelected =
    ruleData.monday ||
    ruleData.tuesday ||
    ruleData.wednesday ||
    ruleData.thursday ||
    ruleData.friday ||
    ruleData.saturday ||
    ruleData.sunday;

  if (!isValid || !isDaySelected) {
    missingFieldsError.value = true;
    console.log("Faltan campos obligatorios o no se seleccionó un día");
    return false;
  } else {
    missingFieldsError.value = false;
    return true;
  }
}

// Watch for changes in the selected project
/* watch(
  () => ruleData.projects_id,
  (newVal) => {
    const selectedProject = projects.value.find(
      (project) => project.id === newVal
    );
    console.log("Selected Project:", selectedProject);
  }
); */
const findChannels = async (elem) => {
  console.log(elem.target.value);
  const response = await getProjectChannels(ruleData.projectsId);
  console.log("Fetched Channels:", response.data);
  ruleData.channels = response.data;
  // Revisar si el proyecto tiene canales
  if (response.data.length === 0) {
    projectHasNoChannels.value = true;
  } else {
    projectHasNoChannels.value = false;
  }
};

// Agregar la clave del sitio de reCAPTCHA
const RECAPTCHA_SITE_KEY = '6LeYVXotAAAAAEpLJ74bmwlfvVoFuZ41xvOlkGzH'; 

const recaptchaToken = ref('');
const recaptchaError = ref('');

const handleRecaptchaVerify = (token) => {
  recaptchaToken.value = token;
  recaptchaError.value = '';
};

const handleRecaptchaError = (error) => {
  recaptchaError.value = 'Error al verificar reCAPTCHA. Por favor, intente nuevamente.';
  console.error('reCAPTCHA error:', error);
};

const handleSubmit = async () => {
  formSubmitted.value = true;

  if (!validateForm()) {
    return;
  }

  try {
    recaptchaError.value = '';
    recaptchaToken.value = '';

    await recaptchaRef.value.executeRecaptcha();

    if (!recaptchaToken.value) {
      recaptchaError.value = 'Por favor, complete la verificación de seguridad.';
      return;
    }

    console.log("Form submitted!");
    console.log("Rule Data:", ruleData);
    
    if (ruleData.contactType === "month") {
      ruleData.isMonth = true;
      ruleData.isWeek = false;
    } else {
      ruleData.isMonth = false;
      ruleData.isWeek = true;
    }

    const payload = {
      startDate: showDates.value ? ruleData.validityStartDate : null,
      endDate: showDates.value ? ruleData.validityEndDate : null,
      monday: ruleData.monday,
      tuesday: ruleData.tuesday,
      wednesday: ruleData.wednesday,
      thursday: ruleData.thursday,
      friday: ruleData.friday,
      saturday: ruleData.saturday,
      sunday: ruleData.sunday,
      notExpire: !ruleData.showDates,
      expire: ruleData.showDates,
      isMonth: ruleData.isMonth,
      isWeek: ruleData.isWeek,
      timesContactDaily: ruleData.timesContactDaily,
      endSchedule: ruleData.endTime,
      startSchedule: ruleData.startTime,
      clientsId: ruleData.clientsId,
      name: ruleData.name,
      projectsId: ruleData.projectsId,
      channels: ruleData.channels,
      //keytypesId: ruleData.keytypesId, //?
      //catperiodId: ruleData.catperiodId, //?
      considerHolidays: holidays.enabled,
      countryCode: holidays.enabled ? holidays.country : null,
      recaptchaToken: recaptchaToken.value
    };

    console.log("Payload:", payload);

    const response = await createRule(payload);
    console.log("Regla creada exitosamente:", response.data);

    ruleCreated.value = true;
    showCreatedRule.value = true;

    setTimeout(() => {
      showCreatedRule.value = false;
      emit('rule-updated');
      emit('close');
    }, 2000);

    const rulesId = response.data.id;
    console.log("rulesId:", rulesId);
  } catch (error) {
    console.error("Error al crear la regla o enviar información de veces a contactar:", error);
  }
}

// checkbox changes
const toggleVigencia = (value) => {
  if (value) {
    showDates.value = true;
  } else {
    showDates.value = false;
  }
};

const toggleModalidad = (value) => {
  if (value) {
    showTimes.value = true;
  } else {
    showTimes.value = false;
  }
};

const errorMessages = ref({});

function validateAndUpdate(event, property) {
  const inputValue = parseInt(event.target.value, 10);
  if (inputValue > 31) {
    ruleData[property] = 31;
    errorMessages.value[property] = `No es posible contactar más de 31 veces`;
  } else {
    ruleData[property] = inputValue;
    errorMessages.value[property] = "";
  }
}
function validateAndUpdateWeek(event, property) {
  const inputValue = parseInt(event.target.value, 10);
  if (inputValue > 7) {
    ruleData[property] = 7;
    errorMessages.value[property] = `No es posible contactar más de 7 veces`;
  } else {
    ruleData[property] = inputValue;
    errorMessages.value[property] = "";
  }
}

const step = ref(1);
const step1Errors = ref({});

function validateStep1() {
  step1Errors.value = {};
  let isValid = true;

  // Validar nombre
  if (!ruleData.name.trim()) {
    step1Errors.value.name = "El nombre de la regla es obligatorio";
    isValid = false;
  }

  // Validar días seleccionados
  const isDaySelected =
    ruleData.monday ||
    ruleData.tuesday ||
    ruleData.wednesday ||
    ruleData.thursday ||
    ruleData.friday ||
    ruleData.saturday ||
    ruleData.sunday;

  if (!isDaySelected) {
    step1Errors.value.days = "Debes seleccionar al menos un día de contacto";
    isValid = false;
  }

  return isValid;
}

function goToStep(n) { 
  if (n === 2 && !validateStep1()) {
    return;
  }
  step.value = n; 
}

function handleNextStep() { 
  if (step.value < 2 && validateStep1()) {
    step.value++;
  }
}

function handlePrevStep() { 
  if (step.value > 1) step.value--; 
}
</script>
<template>
  <div style="width: 100%; height: 100%; position: relative;">
    <button class="close-btn" @click="$emit('close')" aria-label="Cerrar">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#243949" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
    <article v-if="!showCreatedRule">
      <div class="stepper-form-layout">
        <!-- STEPPER VERTICAL -->
        <div class="stepper-vertical stepper-bg" :style="step === 2 ? {height: '750px'} : {height: 'auto'}">
          <div class="step-vertical" :class="{ active: step === 1, completed: step > 1 }">
            <div class="step-circle" :class="{ selected: step === 1, completed: step > 1 }">
              <template v-if="step > 1">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" style="width: 1.3rem; height: 1.3rem; color: #fff;">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
              </template>
              <template v-else>1</template>
            </div>
            <span class="step-label" :class="{ active: step === 1, completed: step > 1 }">Días de contacto</span>
          </div>
          <div class="step-vertical" :class="{ active: step === 2 }">
            <div class="step-circle" :class="{ selected: step === 2 }">
              <template v-if="step > 2">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" style="width: 1.3rem; height: 1.3rem; color: #fff;">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
              </template>
              <template v-else>2</template>
            </div>
            <span class="step-label" :class="{ active: step === 2 }">Condiciones</span>
          </div>
        </div>
        <!-- FORMULARIO -->
        <div class="stepper-form-content" :style="step === 2 ? {width: '100%', overflowY: 'auto', overflowX: 'hidden', maxHeight: '750px', paddingBottom: '50px'} : {}">
          <form v-if="step === 1" @submit.prevent="handleNextStep">
            <p class="form-title">Personaliza tu regla</p>
            <p class="form-description">Elige un nombre para la regla y selecciona los días en los que se enviarán las comunicaciones.</p>
            <div class="mb-3">
              <label class="form-label globals-label" style="font-size: 16px">Nombre de la regla <span class="required-asterisk">*</span></label>
              <input 
                type="text" 
                class="form-control globals-input" 
                :class="{ 'is-invalid': step1Errors.name }"
                placeholder="Escribe el nombre de la regla" 
                v-model="ruleData.name" 
              />
              <div v-if="step1Errors.name" class="invalid-feedback">
                {{ step1Errors.name }}
              </div>
            </div>
            <section class="my-4">
              <p class="form-check-label globals-label">Selecciona los días de contacto <span class="required-asterisk">*</span></p>
              <div class="grid-container">
                <div class="mb-3 form-check" v-for="(day, index) in days" :key="index">
                  <input type="checkbox" class="form-check-input" :id="'checkbox' + index"
                    v-model="ruleData[day.toLowerCase().replace('lunes', 'monday').replace('martes', 'tuesday').replace('miércoles', 'wednesday').replace('jueves', 'thursday').replace('viernes', 'friday').replace('sábado', 'saturday').replace('domingo', 'sunday')]" />
                  <label class="form-check-label" :for="'checkbox' + index">{{ day }}</label>
                </div>
              </div>
              <div v-if="step1Errors.days" class="text-error mt-2">
                {{ step1Errors.days }}
              </div>
            </section>
            <div class="d-flex justify-content-end my-4 gap-3">
              <button class="stepper-nav-btn next" @click="handleNextStep" type="button">
                Continuar
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.2" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" /></svg>
              </button>
            </div>
          </form>
          <form v-else @submit.prevent="handleSubmit">
            <p class="form-title">Condiciones de ejecución</p>
            <p class="form-description">Completa los últimos ajustes para activar tu regla de contacto.</p>
            <!-- Switch: ¿Deseas considerar días festivos? -->
            <div class="condition-row">
              <span class="form-label globals-label">¿Deseas considerar días festivos?</span>
              <span class="switch-group">
                <label class="switch">
                  <input type="checkbox" v-model="holidays.enabled">
                  <span class="slider"></span>
                </label>
                <span class="switch-label">{{ holidays.enabled ? 'Sí' : 'No' }}</span>
              </span>
            </div>
            <div class="divider"></div>
            <div class="mt-3" v-if="holidays.enabled">
              <label class="form-label globals-label" for="country-select">Este país se usará para definir la localización de tus contactos</label>
              <select id="country-select" class="form-select form-select-details" v-model="holidays.country" :disabled="!countriesLoaded">
                <option value="" disabled>Selecciona un país</option>
                <option v-for="(country, index) in countries" :key="index" :value="country.countryCode">{{ country.name }}</option>
              </select>
              <div v-if="!countriesLoaded" class="text-muted mt-2">Cargando países...</div>
            </div>
            <!-- Switch: Vigencia de la regla -->
            <div class="condition-row">
              <span class="form-label globals-label">Vigencia de la regla</span>
              <span class="switch-group">
                <label class="switch">
                  <input type="checkbox" v-model="showDates">
                  <span class="slider"></span>
                </label>
                <span class="switch-label">{{ showDates ? 'Con vigencia' : 'Sin vigencia' }}</span>
              </span>
            </div>
            <div class="divider"></div>
            <div v-if="showDates" class="vigencia-fechas-row">
              <div class="custom-date-input">
                <input type="date" class="form-control custom-date" v-model="ruleData.validityStartDate" />
              </div>
              <div class="custom-date-input">
                <input type="date" class="form-control custom-date" v-model="ruleData.validityEndDate" />
              </div>
            </div>
            <!-- Switch: Modalidad de contacto -->
            <div class="condition-row">
              <span class="form-label globals-label">Modalidad de contacto</span>
              <span class="switch-group">
                <label class="switch">
                  <input type="checkbox" v-model="showTimes">
                  <span class="slider"></span>
                </label>
                <span class="switch-label">{{ showTimes ? 'Contacto semanal' : 'Contacto mensual' }}</span>
              </span>
            </div>
            <div class="divider"></div>
            <div class="mb-3">
              <label for="exampleInputEmail3" class="form-label globals-label">Selecciona tu proyecto asociado <span class="required-asterisk">*</span></label>
              <select id="project" class="form-select form-select-details" v-model="ruleData.projectsId" @change="findChannels($event)">
                <option value="">Selecciona un proyecto</option>
                <option v-for="project in projects" :key="project.projectsId" :value="project.projectsId">{{ project.name }}</option>
              </select>
              <div class="mt-2" v-if="projectHasNoChannels">
                <p class="text-error">Este proyecto no pueder seleccionado, ya que <span style="font-weight: 600">no</span> contiene canales. Selecciona otro proyecto.</p>
              </div>
            </div>
            <div v-if="ruleData.channels && ruleData.channels.length > 0" class="channels-section">
              <p class="channels-hint">
                Agrega número de veces por
                <span class="channels-hint-bold">{{ showTimes ? 'semanal' : 'mensual' }}</span>
                al proyecto seleccionado
              </p>
              <div class="channels-inputs-row">
                <div v-for="(channel, index) in ruleData.channels" :key="index" class="channel-input-group">
                  <label :for="`channel-${index}`" class="channel-label">{{ channel.name }}</label>
                  <input
                    type="number"
                    :id="`channel-${index}`"
                    class="channel-pill-input"
                    min="1"
                    :max="showTimes ? 7 : 31"
                    v-model.number="channel.timesContact"
                  />
                </div>
              </div>
            </div>
            <div v-if="formSubmitted && missingFieldsError" class="text-danger text-center my-3">Todos los campos son obligatorios. Por favor, completa antes de generar la regla.</div>
            <div class="recaptcha-container">
              <ReCaptcha
                ref="recaptchaRef"
                :site-key="RECAPTCHA_SITE_KEY"
                action="create_rule"
                @verify="handleRecaptchaVerify"
                @error="handleRecaptchaError"
              />
              <div v-if="recaptchaError" class="error-message">
                {{ recaptchaError }}
              </div>
            </div>
            <div class="d-flex justify-content-between my-5 gap-4">
              <button class="stepper-nav-btn prev" type="button" @click="handlePrevStep">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.2" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" /></svg>
                Volver
              </button>
              <div class="d-flex gap-3">
                <button class="globals-border-button" type="button" @click="$emit('close')">Cancelar</button>
                <button class="globals-button" type="button" @click="handleSubmit">Crear Regla</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </article>
    <CreatedRule v-if="showCreatedRule" />
  </div>
</template>
<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";

// Layout de stepper y formulario (copiado de proyectos)
.stepper-form-layout {
  display: flex;
  flex-direction: row;
  gap: 2.5rem;
  align-items: stretch;
  width: 100%;
  height: 100%;
  flex: 1 1 auto;
  min-height: 0;
}
.stepper-bg {
  background: $seven-color;
  border-radius: 18px;
  padding: 2.5rem 2rem;
  min-width: 220px;
  box-shadow: 0 2px 8px rgba(33,112,123,0.06);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;
  align-self: stretch;
  height: auto;
  min-height: 0;
  position: relative;
}
.stepper-bg::after {
  content: '';
  display: block;
  flex: 1 1 auto;
  min-height: 1px;
}
.stepper-vertical {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;
  margin-bottom: 2.5rem;
  margin-top: 1.5rem;
  height: 100%;
}
.step-vertical {
  display: flex;
  align-items: center;
  gap: 1.1rem;
  width: 100%;
  margin-bottom: 0.7rem;
}
.step-circle {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  border-radius: 50%;
  background: #fff;
  color: #355E77;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.1rem;
  border: 2px solid #355E77;
  transition: all 0.2s;
  line-height: 1;
  text-align: center;
  box-sizing: border-box;
}
.step-label {
  flex: 1;
  font-family: Mulish;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0%;
  color: #355E77;
  background: #fff;
  border-radius: 10px;
  padding: 0.3rem 2.2rem 0.3rem 1.1rem;
  border: 2px solid #355E77;
  transition: all 0.2s;
  text-align: left;
  display: flex;
  align-items: center;
  min-height: 2.1rem;
}
.step-vertical.active .step-circle {
  background: #355E77;
  color: #fff;
  border: 2px solid #355E77;
}
.step-vertical.completed .step-circle {
  background: #357A3B;
  color: #fff;
  border: 2px solid #357A3B;
}
.step-vertical.active .step-label {
  background: #355E77;
  color: #fff;
  border: 2px solid #355E77;
}
.step-vertical.completed .step-label {
  background: #fff;
  color: #357A3B;
  border: 2px solid #357A3B;
}
.stepper-form-content {
  flex: 1 1 0%;
  background: transparent;
  border-radius: 18px;
  padding: 0 0 0 0.5rem;
  min-width: 0;
  height: 100%;
  min-height: 0;
}
@media (max-width: 900px) {
  .stepper-form-layout {
    flex-direction: column;
    gap: 1.5rem;
  }
  .stepper-bg {
    flex-direction: row;
    min-width: unset;
    min-height: unset;
    width: 100%;
    justify-content: flex-start;
    padding: 1.2rem 0.5rem;
  }
  .stepper-form-content {
    padding: 0;
  }
  .step-vertical {
    width: 100%;
  }
}
// Botones de navegación
.stepper-nav-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  font-family: 'Mulish', sans-serif;
  font-weight: 700;
  font-size: 1.1rem;
  border-radius: 2rem;
  padding: 0.6rem 2.2rem;
  min-width: 120px;
  min-height: 44px;
  transition: background 0.18s, color 0.18s, border 0.18s;
  cursor: pointer;
  box-shadow: none;
  outline: none;
  border: 2px solid #355E77;
  background: #fff;
  color: #355E77;
}
.stepper-nav-btn svg {
  width: 1.3em;
  height: 1.3em;
  vertical-align: middle;
}
.stepper-nav-btn:hover {
  background: $seven-color;
  color: #243949;
  border-color: #243949;
}
.stepper-nav-btn.next {
  background: #355E77;
  color: #fff;
  border: none;
  justify-content: center;
}
.stepper-nav-btn.next:hover {
  background: #243949;
  color: #fff;
}
.text-error {
  color: $error2-color;
  font-size: 0.875rem;
}
.grid-container {
  display: flex;
  flex-direction: row;
  gap: 18px;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
.modal-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: $ultra-white-color;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 90%;
  max-width: 500px;
  position: relative;
  z-index: 10000;
}
.close-btn {
  position: absolute;
  top: 18px;
  right: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 10;
  padding: 4px;
  border-radius: 50%;
  transition: background 0.18s;
}
.close-btn:hover {
  background: #e9ecef;
}
.invalid-feedback {
  display: block;
  color: $error2-color;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.is-invalid {
  border-color: $error2-color !important;
}

.required-asterisk {
  color: $error2-color;
  margin-left: 2px;
}

.condition-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0 12px 0;
  gap: 1.5rem;
}
.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  margin: 0 0 0 8px;
  vertical-align: middle;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e4e7ec;
  border-radius: 24px;
  transition: .4s;
}
.switch input:checked + .slider {
  background-color: #355E77;
}
.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: .4s;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}
.switch input:checked + .slider:before {
  transform: translateX(20px);
}
.switch-label {
  min-width: 90px;
  text-align: left;
  font-size: 15px;
  color: #243949;
  font-weight: 500;
  margin-left: 0;
  margin-right: 0;
  display: inline-block;
  vertical-align: middle;
}
/* Agrupa switch y texto juntos */
.switch-group {
  display: flex;
  align-items: center;
  gap: 8px;
}
.divider {
  border-bottom: 1px solid #e4e7ec;
  margin: 0.5rem 0 0.5rem 0;
}
.vigencia-fechas-row {
  display: flex;
  flex-direction: row;
  gap: 1.2rem;
  margin: 18px 0 10px 0;
}
.custom-date-input {
  position: relative;
  width: 180px;
}
.custom-date {
  background: #f5f7fa;
  border: none;
  border-radius: 2rem;
  padding: 0.7rem 2.5rem 0.7rem 1.2rem;
  font-size: 1rem;
  color: #243949;
  width: 100%;
  box-shadow: none;
  outline: none;
  appearance: none;
}
.custom-date:focus {
  outline: 2px solid #355E77;
}
.calendar-icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}
.form-description {
  font-family: Mulish;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0%;
  color: #545454;
  margin-bottom: 12px;
}
.form-title {
  font-family: Mulish;
  font-weight: 800;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0%;
  color: #006576;
  margin-bottom: 8px;
}
.channels-section {
  margin-top: 8px;
  margin-bottom: 18px;
}
.channels-hint {
  font-family: Mulish;
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 0%;
  color: #006576;
  margin-bottom: 10px;
}
.channels-hint-bold {
  color:#006576;
  font-weight: 700;
}
.channels-inputs-row {
  display: flex;
  flex-direction: row;
  gap: 32px;
  margin-top: 8px;
}
.channel-input-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 120px;
}
.channel-label {
  font-family: Mulish;
  font-weight: 700;
  font-size: 15px;
  color: #243949;
  margin-bottom: 6px;
}
.channel-pill-input {
  background: #f5f7fa;
  border: none;
  border-radius: 2rem;
  padding: 0.7rem 1.2rem;
  font-size: 1rem;
  color: #243949;
  width: 100%;
  min-width: 80px;
  box-shadow: none;
  outline: none;
  appearance: none;
  text-align: center;
}
.channel-pill-input:focus {
  outline: 2px solid #355E77;
}
.recaptcha-container {
  margin: 1rem 0;
  min-height: 50px;
}

.error-message {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.5rem;
}
</style>
